import { isAbortError } from '@reatom/framework';
import { isApiCancel } from '@/js/libs/api';
const isCancelError = (error) => isApiCancel(error) || isAbortError(error);
export default isCancelError;
